import React from 'react';

const LoadingSpinner = ({ text = 'Carregando...' }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="flex items-center gap-3 bg-gray-800 p-4 rounded-lg">
        <div className="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
        <span className="text-dark-text-secondary">{text}</span>
      </div>
    </div>
  );
};

export default LoadingSpinner;
